<div
  class="modal"
  id="dialogFeedback_{{ identificacaoDialog }}"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialogFeedbackTitle"
  aria-hidden="false"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content dialog shadow">
      <div>
        <p
          class="dialog-title"
          i18n="@@tituloDialog"
          id="dialogFeedbackTitle_{{ identificacaoDialog }}"
        >
          {{ titulo }}
        </p>
        <p
          class="dialog-subtitle"
          i18n="@@subTituloDialog"
          id="dialogFeedbackSubtitle_{{ identificacaoDialog }}"
        >
          {{ subTitulo }}
        </p>
      </div>
      <div class="container">
        <div class="scroll-content-table" *ngIf="exibirTabela">
          <table class="grid">
            <thead *ngIf="exibirCabecalhoTabela">
              <tr class="cabecalho">
                <th
                  *ngFor="let cabecalho of informacaoDialog.cabecalhos"
                  scope="col"
                  class="linhas-cabecalho"
                  i18n="@@cabecalhoDialog"
                >
                  {{ cabecalho }}
                </th>
              </tr>
            </thead>
            <tbody *ngIf="exibirMensagemCompostaTabela">
              <tr
                id="linhaMsgDialog"
                *ngFor="let chave of informacaoDialog.mensagens"
              >
                <td
                  class="coluna-dados"
                  *ngFor="let valor of listarValoresMensagem(chave)"
                >
                  {{ valor }}
                </td>
              </tr>
            </tbody>
            <tbody
              *ngIf="exibirMensagemSimplesTabela"
              class="scroll-content-tbody"
            >
              <tr
                id="linhaMsgDialog"
                *ngFor="let mensagem of informacaoDialog.mensagensSimples"
              >
                <td class="coluna-dados" i18n="@@mensagemDialog">
                  {{ mensagem }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="containerInput" *ngIf="exibirInputName">
          <div>
            <label
              id="labelinputPopupFeedback"
              for="inputPopupFeedback"
              class="label-feedback"
              i18n="@@labelInputDialog"
              >{{ labelInputDialog }}</label
            >
            <input
              id="inputPopupFeedback"
              type="text"
              maxlength="25"
              class="input-feedback"
              [value]="valorInput"
              (keyup)="validaPreenchimentoInput($event)"
            />
          </div>
          <span
            id="labelMensagemInput"
            *ngIf="mensagemFeedbackInput !== ''"
            class="feedback-erro"
            i18n="@@mensagemFeedbackInput"
            >{{ mensagemFeedbackInput }}</span
          >
        </div>
      </div>
      <div class="modal-footer dialog-footer">
        <app-button
          color="none"
          btnId="btnCancelarDialog"
          *ngIf="botaoCancelar.mostrar"
          css="btn-light {{
            botaoCancelar.eConfirmacao === false
              ? 'dialog-cancel-button'
              : 'dialog-button'
          }}"
          (onClick)="emitirClique(botaoCancelar)"
          >{{ botaoCancelar.texto }}</app-button
        >
        <button
          id="btnOkDialog"
          *ngIf="botaoOk.mostrar"
          type="button"
          class="btn btn-light"
          i18n="@@botaoOkDialog"
          [ngClass]="
            botaoOk.eConfirmacao === false
              ? 'dialog-cancel-button'
              : 'dialog-button'
          "
          data-dismiss="modal"
          (click)="emitirClique(botaoOk)"
        >
          {{ botaoOk.texto }}
        </button>
        <app-button
          color="none"
          btnId="btnRemoverDialog"
          *ngIf="botaoRemover.mostrar"
          css="btn-light {{
            botaoRemover.eConfirmacao === false
              ? 'dialog-cancel-button'
              : 'dialog-button'
          }}"
          (onClick)="emitirClique(botaoRemover)"
          >{{ botaoRemover.texto }}</app-button
        >
        <app-button
          color="none"
          btnId="btnFecharDialog"
          *ngIf="botaoFechar.mostrar"
          css="btn-light {{
            botaoFechar.eConfirmacao === false
              ? 'dialog-cancel-button'
              : 'dialog-button'
          }}"
          (onClick)="emitirClique(botaoFechar)"
          >{{ botaoFechar.texto }}</app-button
        >
        <app-button
          color="none"
          btnId="btnSalvarDialog"
          *ngIf="botaoSalvar.mostrar"
          css="btn-light btnSalvar {{
            botaoSalvar.eConfirmacao === false
              ? 'dialog-cancel-button'
              : 'dialog-button'
          }}"
          (onClick)="emitirClique(botaoSalvar)"
          [disabled]="!botaoSalvar.habilitado"
          >{{ botaoSalvar.texto }}</app-button
        >
        <div id="loadingContainerBotaoSalvar" [ngClass]="loadingClasse">
          <div class="row justify-content-center">
            <div class="col-md-auto">
              <img id="loadingImgSalvar" src="./assets/img/spinner-125.svg" />
            </div>
            <!-- Força a próxima coluna a quebrar, em uma nova linha -->
            <div class="w-100"></div>
            <div class="col-md-auto">
              <span
                style="font-size: 0.7rem; color: black"
                id="feedBackMsgSalvar"
                >{{ mensagemFeedbackBotaoSalvar }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #elseBlockThead>
  <thead></thead>
</ng-template>
